import React from 'react'

const strokeStyle = { vectorEffect: 'non-scaling-stroke' }

function CrossIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="70.912" height="68.912" viewBox="0 0 70.912 68.912">
      <defs>
        <filter id="Rectangle_34" x="0" y="0" width="68.912" height="68.912" filterUnits="userSpaceOnUse">
          <feOffset dy="3"/>
          <feGaussianBlur stdDeviation="3" result="blur"/>
          <feFlood floodOpacity="0.161"/>
          <feComposite operator="in" in2="blur"/>
          <feComposite in="SourceGraphic"/>
        </filter>
        <filter id="Rectangle_35" x="2" y="0" width="68.912" height="68.912" filterUnits="userSpaceOnUse">
          <feOffset dy="3"/>
          <feGaussianBlur stdDeviation="3" result="blur-2"/>
          <feFlood floodOpacity="0.161"/>
          <feComposite operator="in" in2="blur-2"/>
          <feComposite in="SourceGraphic"/>
        </filter>
      </defs>
      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Rectangle_34)">
        <rect id="Rectangle_34-2" data-name="Rectangle 34" width="4" height="68" rx="2" transform="translate(57.08 6) rotate(45)" fill="#fff"/>
      </g>
      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Rectangle_35)">
        <rect id="Rectangle_35-2" data-name="Rectangle 35" width="4" height="68" rx="2" transform="translate(11 8.83) rotate(-45)" fill="#fff"/>
      </g>
    </svg>

  )
}

export default CrossIcon
